import React from 'react'

import { XTicks as Component } from './XTicks'

const XTicks = props => {
  return <Component {...props} />
}
export default XTicks
